// extracted by mini-css-extract-plugin
export default {"header":"Explore_header__n1F-j","heading":"Explore_heading__Dm91+","tags":"Explore_tags__SFt1V","tag":"Explore_tag__hWcmq"};